// ARCHIVOS DE CONFIGURACIÓN GENERAL //

export class Config {
  // Loading initial logo
  public static LOADING_APP_TIME = 500;

  // Codes
  public static DEFAULT_LANGUAGE_CODE = 'ES';
  public static DEFAULT_COUNTRY_CODE = 'ES';
  public static DEFAULT_CURRENCY_CODE = 'EUR';

  // Date formats
  public static DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
  public static ES_DATE_FORMAT = 'DD/MM/YYYY';
  public static EN_DATE_FORMAT = 'YYYY/MM/DD';
  public static DEFAULT_DATE_FORMAT_FILENAME = 'DDMMYYYYHHmm';
  public static ES_DATE_FORMAT_FILENAME = 'DDMMYYYYHHmm';
  public static EN_DATE_FORMAT_FILENAME = 'MMDDYYYYHHmm';

  // Datetime formats
  public static DEFAULT_DATETIME_FORMAT = 'DD/MM/YYYY - HH:mm:ss';
  public static DEFAULT_DATETIME_FORMAT_NO_SECONDS = 'DD/MM/YYYY - HH:mm';
  public static ES_DATETIME_FORMAT = 'DD/MM/YYYY - HH:mm:ss';
  public static ES_DATETIME_FORMAT_NO_SECONDS = 'DD/MM/YYYY - HH:mm';
  public static EN_DATETIME_FORMAT = 'YYYY/MM/DD - HH:mm:ss';
  public static EN_DATETIME_FORMAT_NO_SECONDS = 'YYYY/MM/DD - HH:mm';

  // Month formats
  public static MONTH_FORMAT = 'MMMM';

  // Time formats
  public static TIME_FORMAT = 'HH:mm:ss';
  public static TIME_FORMAT_NO_SECONDS = 'HH:mm';
  public static TIME_FORMAT_NO_HOUR = 'mm:ss';

  // Dialog size
  public static DIALOG_XS = '350px';
  public static DIALOG_SM = '500px';
  public static DIALOG_MD = '640px';
  public static DIALOG_LG = '1024px';
  public static DIALOG_XL = '1280px';
  public static DIALOG_FULL = '100%';

  // Methods
  public static getDateFormat(lang: string): string {
    switch (lang) {
      case 'es':
        return Config.ES_DATE_FORMAT;
      case 'en':
        return Config.EN_DATE_FORMAT;
      default:
        return Config.DEFAULT_DATE_FORMAT;
    }
  }

  public static getDateTimeFormat(lang: string): string {
    switch (lang) {
      case 'es':
        return Config.ES_DATETIME_FORMAT;
      case 'en':
        return Config.EN_DATETIME_FORMAT;
      default:
        return Config.DEFAULT_DATETIME_FORMAT;
    }
  }

  public static getDateTimeFormatNoSeconds(lang: string): string {
    switch (lang) {
      case 'es':
        return Config.ES_DATETIME_FORMAT_NO_SECONDS;
      case 'en':
        return Config.EN_DATETIME_FORMAT_NO_SECONDS;
      default:
        return Config.DEFAULT_DATETIME_FORMAT_NO_SECONDS;
    }
  }

  public static getDateFormatFileName(lang: string): string {
    switch (lang) {
      case 'es':
        return Config.ES_DATE_FORMAT_FILENAME;
      case 'en':
        return Config.EN_DATE_FORMAT_FILENAME;
      default:
        return Config.DEFAULT_DATE_FORMAT_FILENAME;
    }
  }

  public static getMonthFormat(lang: string): string {
    switch (lang) {
      case 'es':
        return Config.MONTH_FORMAT;
      case 'en':
        return Config.MONTH_FORMAT;
      default:
        return Config.MONTH_FORMAT;
    }
  }

  public static SUCCESS_MESSAGES_PREFIX = 'messages.success';
  public static WARNING_MESSAGES_PREFIX = 'messages.warning';
  public static INFO_MESSAGES_PREFIX = 'messages.info';
  public static ERROR_MESSAGES_PREFIX = 'messages.error';
}
